export default __webpack_public_path__ + "static/media/avatar.3d1eb4ac.png";